import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/storage';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-configuracion-cronometraje',
    templateUrl: './configuracion-cronometraje.component.html',
    styleUrls: ['./configuracion-cronometraje.component.scss']
})
export class ConfiguracionCronometrajeComponent implements OnInit {

    public loading = false;
    public path = null;
    public nombreEvento = null;
    public tipoClasificacion = null;
    public tipoDisciplina = null;
    public dividirPantalla = null;
    public cantidadPorTabla = null;
    public ordenPantalla = null;
    public cantidadMarcajeAdminitracionCat = null;
    public cantidadMarcajeAdminitracionDes = null;
    public cantidadMarcajeAdminitracionGiro = null;
    public cambiarCat = null;
    public desafios = [];
    public desafiosPremiacion = [];
    public marcajeAdmMostrarEnRuta = null;
    public formPath: FormGroup;
    public pestanaSeleccionada = 0;
    public configuracionRanking = null;


    constructor(private router: Router,
        private fb: FormBuilder,
        private localStorageAs: LocalStorageService

    ) { }

    ngOnInit(): void {
        this.path = localStorage.getItem('path');
        this.nombreEvento = localStorage.getItem('nombre_evento');
        this.tipoClasificacion = localStorage.getItem('tipo_clasificacion');
        this.tipoDisciplina = localStorage.getItem('tipo_disciplina');
        this.dividirPantalla = localStorage.getItem('dividir_pantalla');
        this.cantidadPorTabla = localStorage.getItem('cantidad_tabla');
        this.cantidadMarcajeAdminitracionCat = localStorage.getItem('cantidad_marcaje_administracion_cat');
        this.cantidadMarcajeAdminitracionDes = localStorage.getItem('cantidad_marcaje_administracion_des');
        this.cantidadMarcajeAdminitracionGiro = localStorage.getItem('cantidad_marcaje_administracion_giro');
        this.ordenPantalla = localStorage.getItem('orden_pantalla');
        this.cambiarCat = localStorage.getItem('cambiar_cat');
        this.marcajeAdmMostrarEnRuta = localStorage.getItem('marcaje_adm_mostrar_en_ruta');
        this.configuracionRanking = localStorage.getItem('configuracion_ranking');

        this.localStorageAs.watch('desafios').subscribe(desafiosStorage => {
            if (desafiosStorage !== null) {
                this.desafios = JSON.parse(desafiosStorage);

            }
        });

        this.localStorageAs.watch('desafios_premiacion').subscribe(desafiosPremiacionStorage => {
            if (desafiosPremiacionStorage !== null) {
                this.desafiosPremiacion = JSON.parse(desafiosPremiacionStorage);

            }
        });

        this.initForm();
        this.agregarConfiguracionPremiacion();

    }

    initForm() {
        this.formPath = this.fb.group({
            url: [this.path ? this.path : '', Validators.required],
            nombreEvento: [this.nombreEvento ? this.nombreEvento : '', Validators.required],
            tipoClasificacion: [this.tipoClasificacion ? this.tipoClasificacion : '', Validators.required],
            tipoDisciplina: [this.tipoDisciplina ? this.tipoDisciplina : '', Validators.required],
            dividirPantalla: [this.dividirPantalla ? this.dividirPantalla : '', Validators.required],
            cantidadPorTabla: [this.cantidadPorTabla ? this.cantidadPorTabla : 0, Validators.required],
            cantidadMarcajeAdminitracionCat: [this.cantidadMarcajeAdminitracionCat ? this.cantidadMarcajeAdminitracionCat : 0, Validators.required],
            cantidadMarcajeAdminitracionDes: [this.cantidadMarcajeAdminitracionDes ? this.cantidadMarcajeAdminitracionDes : 0, Validators.required],
            cantidadMarcajeAdminitracionGiro: [this.cantidadMarcajeAdminitracionGiro ? this.cantidadMarcajeAdminitracionGiro : 0, Validators.required],
            ordenPantalla: [this.ordenPantalla ? this.ordenPantalla : '', Validators.required],
            cambiarCat: [this.cambiarCat ? this.cambiarCat : '', Validators.required],
            marcajeAdmMostrarEnRuta: [this.marcajeAdmMostrarEnRuta ? this.marcajeAdmMostrarEnRuta : '', Validators.required],
            configuracionPremiacion: this.fb.group({}),
            configuracionRanking: [this.configuracionRanking ? this.configuracionRanking : '', ],
        });
    }

    get items(): FormGroup {
        return this.formPath.get('configuracionPremiacion') as FormGroup;
    }

    agregarConfiguracionPremiacion() {
        const itemGroup = this.fb.group({});

        this.desafios.forEach((desafio) => {
            const cantidad = this.desafiosPremiacion[desafio];
            this.items.addControl(desafio, this.fb.control(cantidad === undefined ? 0 : cantidad, Validators.required));
        });

    }

    update() {
        if (!this.formPath.valid) {
            Swal.fire(
                'Uppps....!',
                'Faltan campos obligatorios',
                'error'
            );
            return;
        }

        localStorage.setItem('path', this.formPath.get('url').value);
        localStorage.setItem('nombre_evento', this.formPath.get('nombreEvento').value);
        localStorage.setItem('tipo_clasificacion', this.formPath.get('tipoClasificacion').value);
        localStorage.setItem('tipo_disciplina', this.formPath.get('tipoDisciplina').value);
        localStorage.setItem('dividir_pantalla', this.formPath.get('dividirPantalla').value);
        localStorage.setItem('cantidad_tabla', this.formPath.get('cantidadPorTabla').value);
        localStorage.setItem('cantidad_marcaje_administracion_cat', this.formPath.get('cantidadMarcajeAdminitracionCat').value);
        localStorage.setItem('cantidad_marcaje_administracion_des', this.formPath.get('cantidadMarcajeAdminitracionDes').value);
        localStorage.setItem('cantidad_marcaje_administracion_giro', this.formPath.get('cantidadMarcajeAdminitracionGiro').value);
        localStorage.setItem('orden_pantalla', this.formPath.get('ordenPantalla').value);
        localStorage.setItem('cambiar_cat', this.formPath.get('cambiarCat').value);
        localStorage.setItem('marcaje_adm_mostrar_en_ruta', this.formPath.get('marcajeAdmMostrarEnRuta').value);
        localStorage.setItem('configuracion_ranking', this.formPath.get('configuracionRanking').value);


        this.localStorageAs.set('desafios_premiacion', JSON.stringify(this.formPath.get('configuracionPremiacion').value));

        Swal.fire(
            'Configuración actualizada!',
            'Se ha guardado la configuración correctamente.',
            'success'
        );

        this.router.navigate(['/marcaje']);
    }

    obtenerTipoDisciplina() {
        return this.formPath.get('tipoDisciplina').value;
    }

    cambioPestana(indice) {
        this.pestanaSeleccionada = indice;
    }

}
